// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"wm_a bhu_b bhu_ux"};